module.exports = __webpack_public_path__ + "media/images/best_employer2018-2022c4cc.png";